import React from "react";
import { Archive, Inbox, Send } from "lucide-react";
import { REQUEST_VIEWS } from "../../utils/requestsHelpers";

const VIEW_NAV = {
  inbox: {
    Icon: Inbox,
    hint: "Invites to join",
    tone: "inbox",
  },
  outbox: {
    Icon: Send,
    hint: "Challenges you posted",
    tone: "outbox",
  },
  all: {
    Icon: Archive,
    hint: "All P2P requests",
    tone: "all",
  },
};

const RequestsFilterNav = ({
  view,
  onViewChange,
  viewCounts,
  replyCount,
  resultCount,
}) => (
  <nav className="req-nav-rail" aria-label="Filter P2P requests">
    <div className="req-nav-panel">
      <header className="req-nav-head">
        <span className="req-nav-kicker">P2P</span>
        <div className="req-nav-summary" aria-label="Queue summary">
          <div className="req-nav-summary-stat">
            <em>Inbox</em>
            <strong className={`tabular-nums ${replyCount > 0 ? "req-nav-summary-urgent" : ""}`}>
              {viewCounts.inbox ?? 0}
            </strong>
          </div>
          <div className="req-nav-summary-stat">
            <em>Sent</em>
            <strong className="tabular-nums">{viewCounts.outbox ?? 0}</strong>
          </div>
          <div className="req-nav-summary-stat">
            <em>Showing</em>
            <strong className="tabular-nums">{resultCount}</strong>
          </div>
          <div className="req-nav-summary-stat">
            <em>All</em>
            <strong className="tabular-nums">{viewCounts.all ?? 0}</strong>
          </div>
        </div>
        <p className="req-nav-headline">
          {replyCount > 0 ? (
            <>
              <span className="req-nav-pulse" aria-hidden />
              <strong className="tabular-nums">{replyCount}</strong> awaiting you
            </>
          ) : (
            "Inbox clear"
          )}
        </p>
      </header>

      <div className="req-nav-group">
        <span className="req-nav-section-label">View</span>
        <div className="req-nav-stack" role="tablist" aria-label="Queue view">
          {REQUEST_VIEWS.map((v) => {
            const meta = VIEW_NAV[v.id];
            const Icon = meta.Icon;
            const active = view === v.id;
            const urgent = v.id === "inbox" && replyCount > 0;
            return (
              <button
                key={v.id}
                type="button"
                role="tab"
                aria-selected={active}
                className={`req-nav-item req-nav-item-${meta.tone} ${
                  active ? "req-nav-item-active" : ""
                } ${urgent && !active ? "req-nav-item-urgent-idle" : ""}`}
                onClick={() => onViewChange(v.id)}
              >
                <span className="req-nav-item-glyph" aria-hidden>
                  <Icon size={14} strokeWidth={2.2} />
                  {urgent ? <span className="req-nav-item-dot" aria-hidden /> : null}
                </span>
                <span className="req-nav-item-copy">
                  <strong>{v.label}</strong>
                  <em>{meta.hint}</em>
                </span>
                <span className="req-nav-item-count tabular-nums">
                  {viewCounts[v.id] ?? 0}
                </span>
                <span className="req-nav-item-bar" aria-hidden />
              </button>
            );
          })}
        </div>
      </div>

      <footer className="req-nav-foot">
        <span className="req-nav-foot-label">Showing</span>
        <strong className="req-nav-foot-count tabular-nums">{resultCount}</strong>
      </footer>
    </div>
  </nav>
);

export default RequestsFilterNav;
